import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { FormGroup, FormControl, UntypedFormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { Tc } from '../../../core/_infrastructure/types/common';
import { ConfirmationService } from 'primeng/api';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { HttpParams } from '@angular/common/http';
import { ComponentBase } from "../../../core/_infrastructure/classes/componentBase";
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';

import { UsuariosService } from '.././usuarios.service';
import { UsuarioViewModel } from '../usuarios.types';
import { Table } from 'primeng/table';

@Component({
    selector: 'app-bulkcas-list',
    templateUrl: './bulkcas-list.component.html'
})
/** usuarioscexveg-list component*/
export class BulkCasListComponent extends ComponentBase{
    /** usuarioscexveg-list ctor */
  

   
    public isCollapsed = false;

    listUsuario: UsuarioViewModel[]

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private confirmationService: ConfirmationService,
        private usuariosService: UsuariosService) {
        super(authService, notificacionService, exceptionHandler);

       
    }

    ngOnInit() {

       

        this.form = this.fb.group({});

        //this.loadBack();
    }

    

    onBulk() {

       

        this.usuariosService.bulkCAS().subscribe(result =>
        {
            this.listUsuario = result;
        }

        );

        
        this.searchingButton = true;
        this.isCollapsed = true;
    }

   


    Search(pageNumber: number, asc: number = 0, orderBy: string = '') {

        
        
        this.loading = true;
        this.usuariosService.bulkCAS().subscribe(result => {

            //this.resultUsuariosCexveg = result;
            this.loading = false;
        });
    }

   

   

    
}
